// extracted by mini-css-extract-plugin
export default {"custom_checkbox_wrapper":"Checkbox_custom_checkbox_wrapper__jvEnV","custom_checkbox":"Checkbox_custom_checkbox__T-fB6","shimmer":"Checkbox_shimmer__3wsr5"};